import { ReactSVG } from "react-svg";
import { FleetWarehouseRow } from "services/api/fleet/warehouses/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const TIRE_SEARCH_COLUMNS = (t: (key: string) => string): Column[] => [
  {
    title: "",
    field: "image",
    type: ColumnTypes.custom,
    render: (row: FleetWarehouseRow) => {
      return (
        <div>
          <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              {row.name.toString().charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      );
    },
  },
  {
    title: "admin.fleet.warehouse.search.name",
    field: "name",
    type: ColumnTypes.string,
  },
  {
    title: "admin.fleet.warehouse.search.address",
    type: ColumnTypes.custom,
    render: (row: FleetWarehouseRow) => {
      if (
        !row?.addressLine1 &&
        !row?.addressPostalCode &&
        !row?.addressCity &&
        !row?.addressCountry
      ) {
        return;
      }

      return (
        <div className="flex gap-3 items-center relative">
          <div className="absolute -left-7">
            <ReactSVG
              src="/media/icons/location.svg"
              className="w-5 h-5 stroke-[#000]"
            />
          </div>
          <div>
            <div className="text-md">{row.addressLine1} </div>
            <div className="font-light">
              {row.addressPostalCode} {row.addressCity}{" "}
              {row?.addressCity && row?.addressCountry ? ", " : ""}
            </div>
          </div>
        </div>
      );
    },
  },
  {
    title: "admin.fleet.warehouse.search.contact",
    type: ColumnTypes.custom,
    render: (row: FleetWarehouseRow) => {
      const contact = row.contacts.length > 0 ? row.contacts[0] : null;

      if (!contact) return;

      return (
        <div className="flex gap-3 items-center relative">
          <div className="absolute -left-7">
            <ReactSVG
              src="/media/icons/phone.svg"
              className="w-5 h-5 stroke-[#000]"
            />
          </div>
          <div>
            <div className="text-md">
              {contact?.firstName}  {contact?.lastName}
            </div>
            {/* <div className="font-light">{contact?.companyName}</div> */}
          </div>
        </div>
      );
    },
  },
];
